import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Reports from './components/reports';
import Main from './main';

export default (
  <Route path="tanque-cheio" name="Tanque Cheio">
    <IndexRoute component={(props) => <Main {...props} />} />
    <Route path="reports/:id" component={Reports} />
  </Route>
);
